import {
  Input,
  InputGroup,
  InputProps,
  InputRightElement,
} from '@chakra-ui/react';
import { IconCalendarEvent } from '@tabler/icons-react';

function CustomInput(props: InputProps, ref: React.Ref<HTMLInputElement>) {
  return (
    <InputGroup>
      <Input ref={ref} {...props} />
      <InputRightElement cursor="pointer" w="48px" {...props}>
        <IconCalendarEvent />
      </InputRightElement>
    </InputGroup>
  );
}

export default CustomInput;
